(function () {
  if (customElements.get('image-compare-slider')) return;

  class ImageCompareSlider extends HTMLElement {
    connectedCallback() {
      this.figure = this.querySelector('.image-compare__figure');
      this.clip = this.querySelector('.image-compare__clip');
      this.handle = this.querySelector('.image-compare__handle');

      if (!this.figure || !this.clip || !this.handle) return;

      this.dragging = false;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.handle.addEventListener('pointerdown', this.onPointerDown);
      this.figure.addEventListener('pointerdown', this.onPointerDown);
      this.handle.addEventListener('keydown', this.onKeyDown);

      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerUp);
    }

    disconnectedCallback() {
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
    }

    onPointerDown(event) {
      this.dragging = true;
      this.updateFromClientX(event.clientX);
      event.preventDefault();
    }

    onPointerMove(event) {
      if (!this.dragging) return;
      this.updateFromClientX(event.clientX);
    }

    onPointerUp() {
      this.dragging = false;
    }

    onKeyDown(event) {
      const current = parseFloat(this.style.getPropertyValue('--start-position')) || 50;
      let next = current;

      if (event.key === 'ArrowLeft') {
        next = Math.max(0, current - 5);
      } else if (event.key === 'ArrowRight') {
        next = Math.min(100, current + 5);
      } else {
        return;
      }

      event.preventDefault();
      this.setPosition(next);
    }

    updateFromClientX(clientX) {
      const rect = this.figure.getBoundingClientRect();
      const percent = ((clientX - rect.left) / rect.width) * 100;
      this.setPosition(Math.min(100, Math.max(0, percent)));
    }

    setPosition(percent) {
      const rounded = Math.round(percent * 10) / 10;
      this.style.setProperty('--start-position', rounded + '%');
      this.handle.setAttribute('aria-valuenow', Math.round(rounded));
    }
  }

  customElements.define('image-compare-slider', ImageCompareSlider);
})();
